import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 1000px;
  padding: 40px 32px;

  @media (min-width: 950px) {
    padding: 48px 68px;
  }
`;

export const TermsContainer = styled.ol`
  max-height: 380px;
  overflow-y: auto;
  border: 1px solid #d8d8d8;
  padding: 28px;
`;

export const Heading2 = styled.h2`
  color: #444;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  text-decoration: underline;
  margin: 24px 0 12px 0;
`;

export const Heading3 = styled.h3`
  color: #444;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 24px 0 12px 0;
`;

export const Heading4 = styled.h4`
  color: #444;
  font-size: 16px;
  font-weight: 700;
  margin: 12px 0 0;
`;

export const Strong = styled.span`
  color: #444;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const Paragraph = styled.p`
  color: #444;
  font-size: 16px;
  margin: 0 0 16px;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 38px;

  > * {
    margin-left: 20px;
  }
`;
